import { userDisplayName } from "../../pages/events/components/EventFunctions";
import EventCardPreview from "./eventcard/EventCardPreview";

export default function EventCard(props) {
  const updatedEvent = props?.event || {};

  if (!updatedEvent?.gameStore) {
    if (updatedEvent?.gameStoreId) {
      updatedEvent.gameStore = {
        id: updatedEvent.gameStoreId,
        name: updatedEvent?.gameStoreName,
        profileImageUrl: updatedEvent?.gameStoreProfileImageUrl
      };
    } else {
      updatedEvent.owner = {
        id: updatedEvent.ownerId || updatedEvent?.owner?.id,
        firstName: updatedEvent?.ownerFirstName,
        lastName: updatedEvent?.ownerLastName,
        name:
          updatedEvent?.ownerFirstName && updatedEvent?.ownerLastName
            ? userDisplayName(
                updatedEvent.ownerFirstName,
                updatedEvent.ownerLastName
              ).trim()
            : "",
        avatarUrl:
          updatedEvent?.ownerAvatarUrl || updatedEvent?.owner?.avatarUrl
      };
    }
  }

  return <EventCardPreview {...props} event={updatedEvent} />;
}
